import { render } from "./BtnToolbar.vue?vue&type=template&id=4238c98f"
import script from "./BtnToolbar.vue?vue&type=script&lang=js"
export * from "./BtnToolbar.vue?vue&type=script&lang=js"
script.render = render

export default script